<!--
 * @Description: 项目人员结算管理
 * @Date: 2024-08-17 16:38:28
-->
<template>
  <table-render
    style="padding: 0;"
    :propData="propData"
    ref="tableRender"
    :config="config"
    rowKey="id"
  ></table-render>
</template>

<script>
import tableRender from '@/components/tableRender';
import config from './config';

export default {
  name: 'projectPersonSettlement',
  data() {
    return {
      propData: { query: { type: 1 } }, //新页面加入参type=1，老页面不传（不知道为什么要这样做）
      config: null
    };
  },
  components: { tableRender },
  watch: {},
  computed: {},
  methods: {},
  created() {
    this.config = config;
  }
};
</script>

<style scoped lang="scss"></style>
